export default __webpack_public_path__ + "static/media/cabinet1-before-2048w.f6e30206.png";